import type { ForwardedRef } from 'react';

import { useImperativeHandle, useMemo } from 'react';

import type { I18nProviderHooks, I18nProviderProps, I18nProviderRef } from './_.type';

/**
 * Use I18nProvider hooks.
 *
 * @param {I18nProviderProps} _props I18nProvider props.
 * @param {I18nProviderRef} ref I18nProvider ref.
 *
 * @returns {I18nProviderHooks} I18nProvider hooks.
 */
export default function useI18nProviderHooks(_props: I18nProviderProps, ref: ForwardedRef<I18nProviderRef>): I18nProviderHooks {
  useImperativeHandle(ref, () => ({}));

  return useMemo<I18nProviderHooks>(
    () => ({
      refs: {},

      states: {},

      events: {},
    }),
    [],
  );
}
